import { format, subDays } from 'date-fns';

import { manifestFilters } from '../pages/Dashboard/components/Filter/ManifestModal';
import { periodFilterToDays } from '../pages/Dashboard/components/Filter/RetrofitDateModal';

// ==========================
// ACTIONS
// ==========================
const CHANGE_FILTERS = 'luft/dashboard-filters/CHANGE_FILTERS';

// ==========================
// STORE INITIAL STATE
// ==========================
const initialState = {
  filters: {
    selectedPeriodInitialDate: '',
    selectedPeriodFinalDate: '',
    byDate: 2,
    initialPeriod: format(
      subDays(new Date(), periodFilterToDays.LAST_30_DAYS),
      'yyyy-MM-dd',
    ),
    finalPeriod: format(new Date(), 'yyyy-MM-dd'),
    listCompany: [],
    listCustomers: [],
    shippingGroupId: 0,
    listUf: [],
    listRegion: [],
    manifestType: manifestFilters.DELIVERY_ONLY,
    keyAccount: '',
    carrierList: [],
  },
};

// ==========================
// REDUCER
// ==========================
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    }
    default:
      return state;
  }
}

// ==========================
// ACTION CREATORS
// ==========================
export function changeFilters(filters = {}) {
  // filters format: { filterKey: newValue, ... }
  return {
    type: CHANGE_FILTERS,
    filters,
  };
}
